<div class="custom-image-display"
	[ngClass]="{ 'icon-mode': iconMode }">
	@if (!loading) {
		@if (resolvedLabel && !iconMode) {
			<div class="image-display-label">
				{{ resolvedLabel }}
			</div>
		}

		<div class="image-display-container"
			[ngClass]="{ 'disabled-image': resolvedIsVisuallyDisabled }">
			@if (hasImage) {
				<p-image
					[src]="imageSource"
					[alt]="resolvedAltText"
					[title]="resolvedDescription ?? resolvedAltText"
					[preview]="resolvedIsClickable">
				</p-image>
			}
			@if (!hasImage && !iconMode) {
				<span class="no-image-message">
					No image available
				</span>
			}
		</div>

		@if (resolvedDescription && !iconMode) {
			<div class="image-display-description">
				{{ resolvedDescription }}
			</div>
		}
	} @else {
		@if (!iconMode) {
			<div class="image-loading-container">
				<i class="pi pi-spin pi-spinner"></i>
			</div>
		}
	}
</div>